import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

export const fetchSubBidangs = async (page = 1, per_page = 10, filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams({
      page,
      per_page,
      ...(filters.jenisPaket && { jenis_paket: filters.jenisPaket }),
      ...(filters.jenisSeleksi && { jenis_seleksi: filters.jenisSeleksi }),
      ...(filters.kategoriPaket && { kategori_paket: filters.kategoriPaket })
    });

    const response = await axios.get(`${BASE_URL_BE}/sub-bidang?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paket:", error);
    throw error;
  }
};

export const createSubBidangs = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/sub-bidang`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating paket:", error);
    throw error;
  }
};

export const updateSubBidangs = async (id_paket, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/sub-bidang/${id_paket}`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};

export const deleteSubBidangs = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/sub-bidang/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting paket:", error);
    throw error;
  }
};





